// extracted by mini-css-extract-plugin
module.exports = {"root":"PopUpHeading_root__1rzGm","heading":"PopUpHeading_heading__3uWiB","closeButton":"PopUpHeading_closeButton__1wKds"};